export default __webpack_public_path__ + "static/Entenda0017-bcf0b765dfa4890a4bf141f33d70f653.jpg";